import { TypedTypePolicies } from 'owa-graph-schema-type-policies';
import { getConfiguration } from 'owa-userconfiguration-cache';

let initialRender = true;

export const unblockBootResolvers = () => {
    initialRender = false;
};

export const createBootPolicies = (): TypedTypePolicies => ({
    Query: {
        fields: {
            userConfiguration: {
                read(existing, { args }) {
                    return initialRender ? getConfiguration(args?.id) : existing;
                },
            },
        },
    },
});
